import { JOB_SPECIAL_CODE } from '@common/jobtype';

// 格式化参数，空值都变成null
export function formatEmptyToNull(param) {
  Object.keys(param).forEach((key) => {
    if (param?.[key]) {
      if (param?.[key]?.length > 0) {
        for (const item of param[key]) {
          Object.keys(item).forEach((subKey) => {
            if (subKey === 'unifiedEntrance' || subKey === 'fullTimeStatus') {
              item[subKey] = item[subKey] === null || item[subKey] === '' ? null : item[subKey];
            } else if (!item[subKey]) item[subKey] = null;
          });
        }
      } else {
        Object.keys(param?.[key]).forEach((subKey) => {
          if (!param[key][subKey]) param[key][subKey] = null;
        });
      }
    }
  });
  return param;
}

/**
 * 处理投递记录页工作地点的展示
 */
export function array2String(cityList: string[], cutLength?: number, separator?: string) {
  let str = '';
  if (!separator) {
    separator = '、';
  }
  if (!Array.isArray(cityList) || (Array.isArray(cityList) && cityList.length === 0)) {
    str = '';
  } else if (cutLength && cityList.length > cutLength) {
    str = `${cityList.slice(0, cutLength).join(separator)}等`;
  } else {
    str = cityList.join('、');
  }
  return str;
}

// 判断是否是校招
export function isCampusFn(jobSpecialCode) {
  return (
    jobSpecialCode === JOB_SPECIAL_CODE.YINGJIE ||
    jobSpecialCode === JOB_SPECIAL_CODE.ZHUANZHENGSHIXI ||
    jobSpecialCode === JOB_SPECIAL_CODE.BEIDOU ||
    jobSpecialCode === JOB_SPECIAL_CODE.QIHANG
  );
}
